export const NOTIFICATION_PUSH = 'NOTIFICATION_PUSH'
export const NOTIFICATION_GET = 'NOTIFICATION_GET'
export const NOTIFICATION_GET_UNSEEN = 'NOTIFICATION_GET_UNSEEN'
export const NOTIFICATION_GET_SEEN = 'NOTIFICATION_GET_SEEN'
export const NOTIFICATION_DB_STORE = 'NOTIFICATION_DB_STORE'